export default __webpack_public_path__ + "static/media/func.a80c5a9d.png";